import { HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { PageType } from '@boels/models';
import { combineLatest, map, Observable } from 'rxjs';
import { CmsFacade } from '../../cms/facade/cms.facade';
import { RedirectService } from '../../redirect/redirect.service';

export const HomeRouteGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<boolean> | boolean => {
  return isCmsPage(state);
};

const isCmsPage = (state: RouterStateSnapshot): Observable<boolean> => {
  const cmsFacade = inject(CmsFacade);
  const redirectService = inject(RedirectService);

  const route: string = state.url;
  cmsFacade.loadPage(route, PageType.CONTENT_PAGE);

  return combineLatest([cmsFacade.activeLoaded$, cmsFacade.isCmsRoute$]).pipe(
    map((latest) => latest[1]),
    map((isCmsRoute) => {
      if (!isCmsRoute && !isSmartEditPage(route)) {
        redirectService.noCaching();
        redirectService.setStatusCode(HttpStatusCode.NotFound);
        return true;
      }

      return isCmsRoute;
    }),
  );
};

const isSmartEditPage = (route: string): boolean => {
  return (route.split('/').pop() as string).includes('cx-preview');
};
